/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {SetscoRoutes} from './SetscoRoutes'
import {CompanyRoutes} from './CompanyRoutes'
import { ErrorsPage } from '../components/errors/ErrorsPage'
import {Logout, useAuth} from '../modules/auth'
import {CompanyAuthPage} from '../modules/company/auth'
import {SetscoAuthPage} from '../modules/setsco/auth'
import {App} from '../App'

import { SearchLabelsWrapper } from '../modules/public/search-labels/SearchLabels'
import { SearchCertificatesWrapper } from '../modules/public/search-certificates/SearchCertificates'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser, lastIsSetsco} = useAuth()
  
  return (
  <BrowserRouter basename={PUBLIC_URL}>
    <Routes>
      <Route element={<App />}>
        <Route path='error/*' element={<ErrorsPage />} />
        <Route path='logout/*' element={<Logout />} />
        <Route path='setsco/logout/*' element={<Logout />} />

        { (currentUser) ? (
        <>
        { currentUser.isSetsco ? (
        <>
        <Route path='ccs/*' element={<MasterLayout />}>'
          <Route path='*' element={<SearchCertificatesWrapper />} />
        </Route>                
        <Route path='sld/*' element={<MasterLayout />}>
          <Route path='*' element={<SearchLabelsWrapper />} />
        </Route>
        <Route path='/*' element={<SetscoRoutes />} />
        
        <Route index element={<Navigate to='/setsco/application-management' />} />
        </>
        ) : (
        <>
        <Route path='ccs/*' element={<MasterLayout />}>'
          <Route path='*' element={<SearchCertificatesWrapper />} />
        </Route>                
        <Route path='sld/*' element={<MasterLayout />}>
          <Route path='*' element={<SearchLabelsWrapper />} />
        </Route>
        <Route path='/*' element={<CompanyRoutes />} />                
        <Route index element={<Navigate to='/company/application-management/applications' />} />
        </>
        )
        }
        </>
        ) : (
        <>
        <Route path='ccs/*' element={<MasterLayout />}>'
          <Route path='*' element={<SearchCertificatesWrapper />} />
        </Route>                
        <Route path='sld/*' element={<MasterLayout />}>
          <Route path='*' element={<SearchLabelsWrapper />} />
        </Route>
        <Route path='auth/*' element={<CompanyAuthPage />} />
        <Route path='setsco/auth/*' element={<SetscoAuthPage />} />
        <Route path='*' element={<Navigate to={lastIsSetsco ? '/setsco/auth' : '/auth'} />} />
        </>
        )}
      </Route>
    </Routes>
  </BrowserRouter>
  )
}

export {AppRoutes}